// This file is automatically generated. Do not edit manually.

import { CustomerOrderType } from "src/api/generated/erp/db/types/tables/customerOrderType";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CustomerOfferToOrderApi {
	export async function getFormInitData(args: {
		customerOrderOfferId: number;
	}): Promise<CustomerOfferToOrderApi_FormInitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOffer/toOrder/getFormInitData",
			method: "POST",
			data: {
				customerOrderOfferId: args.customerOrderOfferId,
			},
		});
		return response as CustomerOfferToOrderApi_FormInitData;
	}

	export async function createCustomerOrderFromOffer(args: {
		customerOrderOfferId: number;
		customerOrderTypeId: number;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOffer/toOrder/createCustomerOrderFromOffer",
			method: "POST",
			data: {
				customerOrderOfferId: args.customerOrderOfferId,
				customerOrderTypeId: args.customerOrderTypeId,
			},
		});
		return response as void;
	}
}

export interface CustomerOfferToOrderApi_FormInitData {
	customerOrderTypeId: number | null | undefined;
	customerOrderTypeOptions: Array<CustomerOrderType>;
}
